module.exports = "<span ng-bind=$ctrl.dayShift></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-group/flight-group-days-shift-arrival/flight-group-days-shift-arrival.html
// module id = 921
// module chunks = 0